import { connect } from 'react-redux'
import ServiceViewTabs from '../../components/services/view/ServiceViewTabs'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    steps: state.serviceEdit.steps.list,
    routeProps: ownProps.routeProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewTabs)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewTabs.ts